import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { Children, cloneElement, isValidElement, useEffect, useState } from "react";
import { apiAddAdditionalItemToNextOrder, apiGetUserCart, apiRemoveLineItem } from "Root/api/apiCheckout";
import toastService from "Root/profile/toastService";
import { useCartHandlers } from "CheckoutComponents/Checkout/hooks";
import { useHistory } from "react-router";
const CartContainer = ({ children, loggedIn, hasOrdered }) => {
    const empty_cart = {
        protein: 0,
        hydration: 0,
        preworkout: 0,
        creatine: 0,
        collagen: 0,
        fiber: 0,
        blenderbottle: 0,
        waterbottle: 0,
    };
    const [updatingItems, setUpdatingItems] = useState([]);
    const [updatingUserCart, setUpdatingUserCart] = useState(false);
    const [cart, setCart] = useState(empty_cart);
    const history = useHistory();
    let isMounted = true;
    const fetchUserCart = async () => {
        if (loggedIn && !hasOrdered) {
            try {
                const data = await apiGetUserCart();
                if (data) {
                    const localCartCopy = { ...empty_cart };
                    data.forEach((item) => {
                        localCartCopy[item.item_type] = item.quantity || 0;
                    });
                    isMounted && setCart(localCartCopy);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    };
    async function addItemToCart(item, callb) {
        const newItems = [...updatingItems];
        newItems.push(item);
        setUpdatingItems(newItems);
        setUpdatingUserCart(true);
        const data = { item };
        try {
            const resp = await apiAddAdditionalItemToNextOrder(data);
            toastService.successMessage(`Added ${resp.item_name} to cart.`);
            setUpdatingUserCart(false);
            setUpdatingItems([...updatingItems.filter((itemName) => itemName !== item)]);
            callb && callb();
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
            callb && callb();
        }
    }
    async function removeItemFromCart(item) {
        setUpdatingUserCart(true);
        const data = { item_key: item };
        try {
            const resp = await apiRemoveLineItem(data);
            toastService.successMessage(`Removed ${resp.item_name} from cart.`);
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    const { addToCart } = useCartHandlers({
        cart,
        setCart,
        updatingUserCart,
        addItemToCart,
        removeItemFromCart,
    });
    const addToCheckoutCart = async (key) => {
        await addToCart(key);
        history.push(`/checkout/new-pdp/`);
        window.location.reload();
    };
    const childrenWithProps = Children.map(children, (child) => {
        if (isValidElement(child)) {
            return cloneElement(child, {
                ...child.props,
                addToCartDirect: addToCheckoutCart,
            });
        }
        return child;
    });
    useEffect(() => {
        fetchUserCart();
        return () => {
            isMounted = false;
        };
    }, []);
    return _jsx(_Fragment, { children: childrenWithProps });
};
export default CartContainer;
